import { useRef, useState, useEffect } from "react";
import styles from "./Header.module.css";
import clsx from "clsx";
import { createPortal } from "react-dom";

interface TaskEventToggleProps {
  isTask: boolean;
  isEvent: boolean;
  onToggle: () => void;
  hasAttendees: boolean;
}

const TaskEventToggle = ({ isTask, isEvent, onToggle, hasAttendees }: TaskEventToggleProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const toggleRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tooltipRef.current && toggleRef.current) {
      const toggleRect = toggleRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();

      setTooltipPosition({
        x: toggleRect.left,
        y: toggleRect.top - tooltipRect.height - 5,
      });
    }
  }, [showTooltip]);

  const handleShowTooltip = () => {
    if (hasAttendees) {
      setShowTooltip(true);
    }
  };

  const handleHiddenTooltip = () => {
    if (hasAttendees) {
      setShowTooltip(false);
    }
  };

  return (
    <div
      className={styles.toggle_container}
      ref={toggleRef}
    >
      {showTooltip &&
        createPortal(
          <div
            ref={tooltipRef}
            className={styles.blockType_tooltip}
            style={{
              left: `${tooltipPosition.x}px`,
              top: `${tooltipPosition.y}px`,
              position: "absolute",
            }}
          >
            <span>Event with guests cannot be converted to task</span>
          </div>,
          document.body
        )}
      <label className={styles.toggle}>
        <input
          type="checkbox"
          checked={!isTask}
          disabled={hasAttendees}
          onChange={onToggle}
        />
        <span className={styles.slider}>
          <div>
            <div
              className={styles.slider_text_box}
              onMouseEnter={handleShowTooltip}
              onMouseLeave={handleHiddenTooltip}
            >
              <span className={clsx(styles.slider_text_Task, { [styles.selected_text]: isTask })}>
                Task
              </span>
            </div>
            <div className={styles.slider_text_box}>
              <span className={clsx(styles.slider_text_Event, { [styles.selected_text]: isEvent })}>
                Event
              </span>
            </div>
          </div>
        </span>
      </label>
    </div>
  );
};

export default TaskEventToggle;
